import { useTranslation } from 'react-i18next';

const useDb = () => {
  const { t } = useTranslation();

  const db = [
    {
      vendors: [
        /*
        {
          name: "ClubHouse Konto",
          options: [
            { option: t("sales.deposit"), color: "#fcad89", type: 1 },
            { option: t("sales.withdraw"), color: "#fc86c1", type: 2 },
            { option: t("sales.transfer"), color: "#5b45b0", type: 3 },
          ],
        },
        */
        {
          name: 'Clubhouse Spill',
          options: [
            { option: t('sales.newTicket'), color: '#009e82', type: 3 },
            { option: t('sales.payout'), color: '#fc86c1', type: 5 },
            { option: t('sales.refill'), color: '#fcad89', type: 6 },
          ],
        },
        {
          name: 'WinGames',
          options: [
            { option: t('sales.newTicket'), color: '#009e82', type: 4 },
            { option: t('sales.payout'), color: '#fc86c1', type: 5 },
            { option: t('sales.refill'), color: '#fcad89', type: 6 },
            { option: t('sales.scan'), color: '#8a9dad', type: 8 },
          ],
        },
        {
          name: 'OK Databingo',
          options: [
            { option: t('sales.newTicket'), color: '#009e82', type: 4 },
            { option: t('sales.payout'), color: '#fc86c1', type: 5 },
            { option: t('sales.refill'), color: '#fcad89', type: 6 },
            { option: t('sales.scan'), color: '#8a9dad', type: 8 },
          ],
        },
        // Papir/Kiosk colours are product identities: OkLCh L<=60, chroma 0.100, hues >=35 deg apart
        {
          name: t('sales.paper'),
          options: [
            { option: 'Super Bingo', color: '#9c6da7', type: 1 }, // violet
            { option: 'Kingo', color: '#a67537', type: 101 }, // amber
            { option: 'Xtipp', color: '#2689aa', type: 102 }, // cyan
            { option: 'Flax', color: '#688845', type: 103 }, // green
          ],
        },
        /*
        {
          name: 'Norsk Tipping',
          options: [
            { option: t('sales.NTInn'), color: '#009e82', type: 13 },
            { option: t('sales.NTUt'), color: '#fc86c1', type: 14 },
            { option: t('sales.scan'), color: '#8a9dad', type: 8 },
          ],
        },
        */

        // Kiosk options were all the same blue, so they are now differentiated
        {
          name: 'Kiosk',
          options: [
            { option: t('sales.spillerkonto'), color: '#7a77ba', type: 11 }, // violet
            { option: t('sales.cardPaymentItem'), color: '#188d7c', type: 10 }, // teal
            { option: t('sales.product'), color: '#b66963', type: 9 }, // rust
            { option: t('header.printLastTrans'), color: '#728094', type: 12 }, // slate
          ],
        },
        /*
        {
          name: 'EBS',
          options: [
            { option: t('sales.newTicket'), color: '#009e82', type: 24 },
            { option: t('sales.payout'), color: '#fc86c1', type: 25 },
            { option: t('sales.refill'), color: '#fcad89', type: 26 },
            { option: t('sales.scan'), color: '#8a9dad', type: 8 },
          ],
        },
        */
      ],
    },
  ];

  return db;
};

export default useDb;
